import React from "react";
import PropTypes from "prop-types";
import { Switch } from "react-router-dom";
import { Fader } from "../";

const AnimatedSwitch = ({
  timeout,
  children,
  className,
  location,
  firstPath,
  secondPath
}) => {
  let normalizedLocation = location.pathname.slice(1);

  if (firstPath) {
    //take only first route path parameter
    const firstIndexOfSlash = normalizedLocation.indexOf("/");
    if (firstIndexOfSlash > -1) {
      normalizedLocation = normalizedLocation.substring(0, firstIndexOfSlash);
    }
  }

  if (secondPath) {
    //take only from the second route path parameter
    const secondIndexOfSlash = normalizedLocation.split("/", 2).join("/")
      .length;
    if (secondIndexOfSlash > -1) {
      normalizedLocation = normalizedLocation.substring(0, secondIndexOfSlash);
    }
  }

  return (
    <Fader uKey={normalizedLocation} timeout={timeout} className={className}>
      <Switch location={location}>{children}</Switch>
    </Fader>
  );
};

AnimatedSwitch.propTypes = {
  firstPath: PropTypes.bool,
  secondPath: PropTypes.bool,
  timeout: PropTypes.number,
  className: PropTypes.string,
  location: PropTypes.object,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export default AnimatedSwitch;



// WEBPACK FOOTER //
// ./src/components/common/AnimatedSwitch/AnimatedSwitch.js